import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { Depo20FormData } from '@/types/depo20';

interface ApiResponse<T> {
  value: T;
}

export const getDepo20List = async (oid: number): Promise<Depo20FormData> => {
  try {
    const res = await apiClient.post<ApiResponse<Depo20FormData>>(
      Endpoints.CargarFormularioDepo20,
      {
        oidLiquidacion: oid,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
